/**
 * @description: 工单时间类型
 */
export enum TIME_TYPES {
  // 创建时间
  // 更新时间
  // 回应截止时间
  CREATE_TIME = 'created_at',
  UPDATE_TIME = 'updated_at',
  REPLY_DEADLINE = 'reply_deadline_at',
}

/**
 * @description: 工单排序类型
 */
export enum ORDER_TYPES {
  ASC = 'asc', // 升序
  DESC = 'desc', // 降序
}

/**
 * @description: 工单状态
 */
export enum TICKET_STATUS {
  RESOLVED = 1, // 已解决
  UNPROCESSING = 2, // 待处理
  PENDING = 3, // 待定
  WAITING_FOR_CUSTOMERS = 4, // 等待客户
  WAITING_FOR_A_THIRD_PARTY = 5, // 等待第三方
}

/**
 * @description: 是否包含
 */
export enum FILTER_INCLUDES {
  YES = 1, // 包含
  NO = 0, // 不包含
}

/**
 * @description: 工单类型
 */
export enum TICKET_TYPE {
  ROBOT_TICKET = 1, // 机器人工单
  MANUAL_WORK_TICKET = 2, // 人工工单
}

/**
 * @description: 是否垃圾邮件
 */
export enum IS_SPAM {
  YES = 1, // 是
  NO = 0, // 不是
}

/**
 * @description: 是否 AI 识别中
 */
export enum IS_AI_IDENTIFY {
  YES = 1, // 是
  NO = 0, // 不是
}

/**
 * @description: 邮件状态
 */
export enum EMAILSSTATUS {
  DEFAULT = 0, // 默认状态
  PROGRESS = 1, // 进行中
  SENT = 2, // 已发送
  READ = 3, // 已读
  FAIL = 4, // 失败
  REVOKE = 5, // 撤回
}

/**
 * @description: 邮件状态
 */
export enum EMAILTYPE {
  CUSTOMER = 1, // 客户
  USER = 2, // 客服
  REMARK = 3, // 备注
}

/**
 * @description: 不同类型的邮件工单唯一标识
 */
export enum EMAIL_TICKET_TYPE_FLAG {
  ALL = 'EMAIL_TICKET_ALL', // 所有邮件
  SEARCH = 'EMAIL_SEARCH', // 所有邮件
  PENDING = 'EMAIL_TICKET_PENDING', // 待定
  RESOLVED = 'EMAIL_TICKET_RESOLVED', // 已解决
  UNPROCESSING = 'EMAIL_TICKET_UNPROCESSING', // 待处理
  UNALLOCATED = 'EMAIL_TICKET_UNALLOCATED', // 待分配
}

export enum AI_TYPES {
  N1 = '1', // 1
  N2 = '2', // 2
  N4 = '3', // 3
  N5 = '4', // 4
  '未识别' = '5', // 5
  '高风险' = '6', // 6
  // '重新打开' = 7, // 7
}
